import { render, staticRenderFns } from "./AddApply.vue?vue&type=template&id=28b54308&scoped=true&"
import script from "./AddApply.vue?vue&type=script&lang=js&"
export * from "./AddApply.vue?vue&type=script&lang=js&"
import style0 from "./AddApply.vue?vue&type=style&index=0&id=28b54308&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b54308",
  null
  
)

export default component.exports